import { useSelector } from 'react-redux';
import { getDayDate } from './dateTime';
import {
  COMMA_JOIN,
  MULTIPLE_DATE_TEXT,
  VENUE_DETAILS_JOIN,
} from '../assets/copy';
import { removeHtmlTags } from './stringHelperMethods';

export const useShortVenueDetails = () => {
  const { list: neighborhoods } = useSelector((state) => state.neighborhoods);

  const getNeighborhoodName = (venue) => {
    return neighborhoods?.find(
      (neighborhood) => neighborhood.id === venue.neighborhoodId
    )?.name;
  };

  const getShortVenueDetails = (venue) => {
    const neighborhood = getNeighborhoodName(venue);
    switch (venue.venueType) {
      case 'EVENT':
        const eventDate =
          venue.eventDates?.length === 1
            ? getDayDate(venue.eventDates[0])
            : MULTIPLE_DATE_TEXT;
        const location = [venue.city, venue.state]
          .filter(Boolean)
          .join(COMMA_JOIN);
        return [eventDate, location].filter(Boolean).join(VENUE_DETAILS_JOIN);
      case 'REGULAR':
      default:
        return getShortDescriptionForRegularVenue(venue, neighborhood);
    }
  };

  const getShortVenueDescription = (venue) => {
    const neighborhood = getNeighborhoodName(venue);
    switch (venue.venueType) {
      case 'EVENT':
        const resolvedDescription = venue.descriptionShort
          ? venue.descriptionShort
          : venue.description;
        return removeHtmlTags(
          resolvedDescription.replaceAll(/((<br>)|(<br\/>))/g, ' ')
        );
      case 'REGULAR':
      default:
        return getShortDescriptionForRegularVenue(venue, neighborhood);
    }
  };

  function getShortDescriptionForRegularVenue(venue, location) {
    const cuisine = venue?.cuisines?.items[0]?.cuisine?.name;
    const priceRange = venue.priceRange;
    return [cuisine, priceRange, location]
      .filter(Boolean)
      .join(VENUE_DETAILS_JOIN);
  }

  const getSignatureVenueDetails = (venue) => {
    const neighborhood = getNeighborhoodName(venue);
    const cuisine = venue?.cuisines?.items[0]?.cuisine?.name;
    return [cuisine, neighborhood].filter(Boolean).join(VENUE_DETAILS_JOIN);
  };

  return {
    getShortVenueDetails,
    getShortVenueDescription,
    getSignatureVenueDetails,
    getShortDescriptionForRegularVenue,
    getNeighborhoodName,
  };
};
